import * as React from "react";
import {FC} from "react";
import {Controller, useFormContext} from "react-hook-form";
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-tomorrow";

import {FormData} from "../types/MailTypes";

type JSONEditorProps = {
  mailIndex: number
}

export const JSONEditor: FC<JSONEditorProps> = ({mailIndex}) => {
  const form = useFormContext<FormData>();
  const {control} = form;

  return (
    <div style={{width: '100%'}}>
      <Controller
        control={control}
        name={`mails.${mailIndex}.mail`}
        defaultValue={""}
        render={({field: {onChange, value}}) => {
          return <AceEditor
            height={"500px"}
            mode="json"
            theme="tomorrow"
            value={value}
            onChange={onChange}
            name="jsonEditor"
            editorProps={{$blockScrolling: true}}
            placeholder={"Brick JSON"}
            width={"100%"}
          />
        }}
      />
    </div>
  );
}